import { Stack, Typography } from "@mui/material"
import tratativaDeDatas from "../../../../../../../helpers/tratativaDeDatas";

export default function InfoRetencao({ resposta }: InfoRetencaoProps) {

    const { add_retencao, retencoes } = resposta

    return (
        <Stack>
            <Typography variant="caption" component='div' my={0.5}>Adicionar Retenção: <b>{add_retencao === "true" ? "Sim" : "Não"}</b></Typography>
            
            {
                retencoes?.length > 0 && retencoes.filter(retencao => retencao.checked).map((retencao, index) => (
                    <Typography 
                        key={index} 
                        variant="caption" 
                        component='div' 
                        my={0.5}
                    >
                        {retencao.retencao.descricao} - <b>{retencao.valor}</b> ({tratativaDeDatas(retencao.vencimento)})
                    </Typography>
                ))
            }
        </Stack>
    )
}   

interface InfoRetencaoProps {
    resposta: RespostaRetencao
}

interface RespostaRetencao {
    add_retencao: string;
    retencoes: RetencaoItem[];
}

interface Retencao {
    id: number;
    descricao: string;
    tipo_favorecido: string;
    codigo_favorecido: number;
    tipo_documento: string;
    serie: string;
}

interface RetencaoItem {
    retencao: Retencao;
    vencimento: string | null;
    valor: string;
    checked: boolean;
}

